<form [formGroup]="form">
    <ng-container *ngIf="!design_pattern || design_pattern ==1">
        <mat-form-field [floatLabel]="floatLabel" [ngClass]="{'no-label':!label,'label-overflow':label_overflow}"
            [appearance]="appearance">
            <mat-label> {{label |translate}} </mat-label>
            <input type="text" matInput id="tallite_mask_input_fields" (keyup)="passKeyup($event)" autocomplete="off"
                [required]="mandatory" [formControlName]="'pass'" [placeholder]="placeholder |translate"
                [minLength]="minLength" [maxLength]="maxLength>0?maxlength:50">
            <i matSuffix style="font-size: 12px;" class="mx-1" *ngIf="hide"> {{actualPassword.join('')}} </i>
            <i class="pointer fa" matSuffix (click)="hide= !hide" [ngClass]="{
                    'fa-eye-slash': !hide,
                    'fa-eye': hide
                  }"></i>
            <mat-error *ngIf="form.get(['pass']).hasError('required');else maxlength">
                {{"ERROR.field_is_mandatory"|translate}}
                <!-- <span [innerHTML]="label + ' is mandatory'"></span> -->
            </mat-error>
            <ng-template #maxlength>
                <mat-error *ngIf="form.get(['pass']).hasError('maxlength');else minlength">
                    {{"ERROR.max_length"|translate}} {{form.get(['pass']).errors && form.get(['pass']).errors.maxlength
                    ?form.get(['pass']).errors.maxlength.requiredLength : maxLength}}
                    <!-- Maximum length ({{maxLength}}) has exceeded -->
                </mat-error>
            </ng-template>
            <ng-template #minlength>
                <mat-error *ngIf="form.get(['pass']).hasError('minlength');else maxvalue">
                    {{"ERROR.minimum_length"|translate}} {{form.get(['pass']).errors &&
                    form.get(['pass']).errors.minlength
                    ?form.get(['pass']).errors.minlength.requiredLength : minLength}}
                    <!-- Minimum length must be {{minLength}} digits -->
                </mat-error>
            </ng-template>
            <ng-template #maxvalue>
                <mat-error *ngIf="form.get(['pass']).hasError('max');else minvalue">
                    {{"ERROR.max_value_1"|translate}} {{maxValue}}
                    <!-- Value must be lesser than {{maxValue}} -->
                </mat-error>
            </ng-template>
            <ng-template #minvalue>
                <mat-error *ngIf="form.get(['pass']).hasError('min'); else pattern">
                    {{"ERROR.min_value_1"|translate}} {{minValue}}
                    <!-- Value must be greater than {{minValue}} -->
                </mat-error>
            </ng-template>
            <ng-template #pattern>
                <mat-error *ngIf="form.get(['pass']).hasError('pattern');else mismatch">
                    {{ 'ERROR.invalid_input'|translate}}
                </mat-error>
            </ng-template>
            <ng-template #mismatch>
                <mat-error *ngIf="form.controls.pass.errors?.notEqual && enable_mismatch">
                    {{'EMPLOYER.password_mismatch' | translate}}
                </mat-error>
            </ng-template>
            <!-- {{form.controls.pass.errors |json}} -->
        </mat-form-field>
    </ng-container>
</form>


<ng-container *ngIf=" design_pattern ==2">
    <form [formGroup]="form_group">
        <mat-form-field [floatLabel]="floatLabel" [ngClass]="{'no-label':!label,'label-overflow':label_overflow}"
            [appearance]="appearance">
            <mat-label> {{label |translate}} </mat-label>
            <input [type]="hide?'text':'password'" matInput autocomplete="off" [required]="mandatory"
                [formControlName]="form_control" [placeholder]="placeholder |translate" [minLength]="minLength"
                [maxLength]="maxLength>0?maxlength:50">

            <i class="pointer fa" matSuffix (click)="hide= !hide" [ngClass]="{
                'fa-eye-slash': !hide,
                'fa-eye': hide
              }"></i>
            <mat-error *ngIf="form.get(['pass']).hasError('required');else maxlength">
                {{"ERROR.field_is_mandatory"|translate}}
                <!-- <span [innerHTML]="label + ' is mandatory'"></span> -->
            </mat-error>
            <ng-template #maxlength>
                <mat-error *ngIf="form.get(['pass']).hasError('maxlength');else minlength">
                    {{"ERROR.max_length"|translate}} {{form.get(['pass']).errors && form.get(['pass']).errors.maxlength
                    ?form.get(['pass']).errors.maxlength.requiredLength : maxLength}}
                    <!-- Maximum length ({{maxLength}}) has exceeded -->
                </mat-error>
            </ng-template>
            <ng-template #minlength>
                <mat-error *ngIf="form.get(['pass']).hasError('minlength');else maxvalue">
                    {{"ERROR.minimum_length"|translate}} {{form.get(['pass']).errors &&
                    form.get(['pass']).errors.minlength
                    ?form.get(['pass']).errors.minlength.requiredLength : minLength}}
                    <!-- Minimum length must be {{minLength}} digits -->
                </mat-error>
            </ng-template>
            <ng-template #maxvalue>
                <mat-error *ngIf="form.get(['pass']).hasError('max');else minvalue">
                    {{"ERROR.max_value_1"|translate}} {{maxValue}}
                    <!-- Value must be lesser than {{maxValue}} -->
                </mat-error>
            </ng-template>
            <ng-template #minvalue>
                <mat-error *ngIf="form.get(['pass']).hasError('min'); else pattern">
                    {{"ERROR.min_value_1"|translate}} {{minValue}}
                    <!-- Value must be greater than {{minValue}} -->
                </mat-error>
            </ng-template>
            <ng-template #pattern>
                <mat-error *ngIf="form.get(['pass']).hasError('pattern');else mismatch">
                    {{ 'ERROR.invalid_input'|translate}}
                </mat-error>
            </ng-template>
            <ng-template #mismatch>
                <mat-error *ngIf="form.controls.pass.errors?.notEqual && enable_mismatch">
                    {{'EMPLOYER.password_mismatch' | translate}}
                </mat-error>
            </ng-template>
            <!-- {{form.controls.pass.errors |json}} -->
        </mat-form-field>
    </form>

</ng-container>